module.exports = __webpack_public_path__ + "static/img/senlin_3.fe040a46.png";